export default "__VITE_ASSET__B7kDD4$Z__"